// extracted by mini-css-extract-plugin
module.exports = {"CardWrapper":"CardWrapper_CardWrapper__Qyfi6","NoShadow":"CardWrapper_NoShadow__vIx9v"};